import { collection, getCountFromServer } from "firebase/firestore";
import { firestore } from "../../config/firebase";

const getUsersCount = async() => {
    const usersCollection = collection(firestore, "users");
    const snapshot = await getCountFromServer(usersCollection);
    return snapshot.data().count;
}

export default getUsersCount;